<template>
    <svg :width="size" :height="Number(size) + 1" viewBox="0 0 5 7" fill="none" xmlns="http://www.w3.org/2000/svg" class="play-filled">
        <path 
            d="M5.01254 3.92213L1.0427 6.1578C0.705796 6.34734 0.273438 6.11783 0.273438 5.73574V1.26439C0.273438 0.8829 0.705172 0.652793 1.0427 0.842934L5.01254 3.0786C5.08918 3.12107 5.15288 3.18245 5.19719 3.25652C5.2415 3.33059 5.26484 3.41472 5.26484 3.50037C5.26484 3.58602 5.2415 3.67014 5.19719 3.74422C5.15288 3.81829 5.08918 3.87967 5.01254 3.92213V3.92213Z" 
            :fill="color"
        />
    </svg>
</template>

<script>
export default {
    props: {
        size: { type: String, default: '6' },
        color: { type: String, default: '#F4F1FF' },
        hoverColor: { type: String, default: '#8869fd' },
    },
};
</script>

<style scoped>
.play-filled {
    transition: fill 0.3s ease;
    fill: v-bind(color);
}

.play-filled:hover path {
    fill: v-bind(hoverColor);
}
</style>